import Work1 from "../../assets/work-1.svg";
import Work2 from "../../assets/work-2.svg";
import Work3 from "../../assets/work-3.svg";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "OCR",
        category: ["Deep Learning"],
        url: "",
        repositoryUrl: "https://github.com/JavonGit/chTrOCR"
    },
    {
        id: 2,
        image: Work2,
        title: "Action Recognition",
        category: ["Machine Learning"],
        url: "",
        repositoryUrl: "https://github.com/JavonGit/ActionRecognition"
    },
    {
        id: 3,
        image: Work3,
        title: "Flower Detection",
        category: ["Object Detection"],
        url: "",
        repositoryUrl: "https://github.com/JavonGit/FlowDetection"
    }
];

export default Menu;
